import { combineReducers } from 'redux'
import PerTypes from 'store/actionTypes/per'
import { createHandleRequest } from './helpers'

const pers = createHandleRequest(
  PerTypes.GET_PERS_REQUEST,
  PerTypes.GET_PERS_SUCCESS,
  PerTypes.GET_PERS_FAILED
)

const getPerAlerts = createHandleRequest(
  PerTypes.GET_PER_ALERTS_REQUEST,
  PerTypes.GET_PER_ALERTS_SUCCESS,
  PerTypes.GET_PER_ALERTS_FAILED
)

const getPerPackageLogs = createHandleRequest(
  PerTypes.GET_PER_PACKAGE_LOGS_REQUEST,
  PerTypes.GET_PER_PACKAGE_LOGS_SUCCESS,
  PerTypes.GET_PER_PACKAGE_LOGS_FAILED
)

const publishIOTService = createHandleRequest(
  PerTypes.PUBLISH_IOT_SERVICE_REQUEST,
  PerTypes.PUBLISH_IOT_SERVICE_SUCCESS,
  PerTypes.PUBLISH_IOT_SERVICE_FAILED
)

const getVehicleTripBy = createHandleRequest(
  PerTypes.GET_VEHICLE_TRIP_DETAIL_REQUEST,
  PerTypes.GET_VEHICLE_TRIP_DETAIL_SUCCESS,
  PerTypes.GET_VEHICLE_TRIP_DETAIL_FAILED
)

const getVehicleTrips = createHandleRequest(
  PerTypes.GET_VEHICLE_TRIPS_REQUEST,
  PerTypes.GET_VEHICLE_TRIPS_SUCCESS,
  PerTypes.GET_VEHICLE_TRIPS_FAILED
)

const exportVehicleTripBy = createHandleRequest(
  PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_REQUEST,
  PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_SUCCESS,
  PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_FAILED
)

const getMqttMessageLogs = createHandleRequest(
  PerTypes.GET_MQTT_MESSAGE_LOGS_REQUEST,
  PerTypes.GET_MQTT_MESSAGE_LOGS_SUCCESS,
  PerTypes.GET_MQTT_MESSAGE_LOGS_FAILED
)

const getDownloadableFirmwareVersions = createHandleRequest(
  PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_REQUEST,
  PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_SUCCESS,
  PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_FAILED
)

const getDownloadableKitConfigurationVersions = createHandleRequest(
  PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_REQUEST,
  PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_SUCCESS,
  PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_FAILED
)

const prepareEncryption = createHandleRequest(
  PerTypes.PREPARE_ENCRYPTION_REQUEST,
  PerTypes.PREPARE_ENCRYPTION_SUCCESS,
  PerTypes.PREPARE_ENCRYPTION_FAILED
)

const downloadCipheredFirmware = createHandleRequest(
  PerTypes.DOWNLOAD_CIPHERED_FIRMWARE_REQUEST,
  PerTypes.DOWNLOAD_CIPHERED_FIRMWARE_SUCCESS,
  PerTypes.DOWNLOAD_CIPHERED_FIRMWARE_FAILED
)

export default combineReducers({
  pers,
  getPerAlerts,
  getPerPackageLogs,
  publishIOTService,
  getVehicleTripBy,
  getVehicleTrips,
  exportVehicleTripBy,
  getMqttMessageLogs,
  getDownloadableFirmwareVersions,
  getDownloadableKitConfigurationVersions,
  prepareEncryption,
  downloadCipheredFirmware
})
